// extracted by mini-css-extract-plugin
export default {"pricingList":"ma","pricingFootnote":"na","switchWrapper":"oa","faqWrapper":"pa","blinking":"qa"};